module.exports = __webpack_public_path__ + "static/img/gong.2df5c47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/gong.png
// module id = lfbH
// module chunks = 4